export default "__VITE_ASSET__D57n5ykB__"